export default __webpack_public_path__ + "static/media/logo.d369a3b7.png";